import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AreaInput, EditorShell, Field, PanelShell, RowActions, TextInput, del, useCrud } from "@/components/admin/ui";
import { SingleImageUpload } from "@/components/admin/ImageUpload";

const empty = { name: "", role: "", region: "", image: "", order: 0 };

export const PartnersPanel = () => {
  const { items, load } = useCrud("partners");
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      if (form.id) await api.put(`/partners/${form.id}`, form);
      else await api.post("/partners", { ...form, order: items.length });
      toast.success("已保存");
      setForm(null);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PanelShell title="合作伙伴" onAdd={() => setForm({ ...empty, order: items.length })}>
      <div className="space-y-2" data-testid="admin-partners-list">
        {items.length === 0 && (
          <div className="border border-dashed border-white/15 py-16 text-center">
            <p className="font-zh text-[#a1a1aa]">暂无合作伙伴 — 点击「新增」添加</p>
          </div>
        )}
        {items.map((p) => (
          <div key={p.id} className="flex items-center justify-between gap-4 border border-white/10 bg-[#0a0a0a] px-4 py-3">
            <div className="flex items-center gap-4 min-w-0">
              {p.image && <img src={p.image} alt="" className="w-14 h-14 object-contain bg-black border border-white/10 shrink-0" />}
              <div className="min-w-0">
                <div className="font-zh text-sm text-white truncate">{p.name}</div>
                <div className="font-mono2 text-[10px] text-[#52525b] truncate">
                  {[p.role, p.region].filter(Boolean).join(" · ")}
                </div>
              </div>
            </div>
            <RowActions
              onEdit={() => setForm(p)}
              onDelete={async () => {
                if (await del("partners", p.id, p.name)) load();
              }}
            />
          </div>
        ))}
      </div>
      {form && (
        <EditorShell title={form.id ? "编辑合作伙伴" : "新增合作伙伴"} onClose={() => setForm(null)} onSubmit={save} busy={busy}>
          <Field label="名称 NAME">
            <TextInput required data-testid="admin-partner-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="SKYLINE ENTERTAINMENT" />
          </Field>
          <div className="grid grid-cols-2 gap-4">
            <Field label="合作内容 ROLE">
              <TextInput value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} placeholder="Organizer & Management" />
            </Field>
            <Field label="地区 REGION">
              <TextInput value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })} placeholder="Worldwide" />
            </Field>
          </div>
          <Field label="标志 LOGO">
            <SingleImageUpload value={form.image} onChange={(url) => setForm({ ...form, image: url })} testid="admin-partner-logo" />
          </Field>
        </EditorShell>
      )}
    </PanelShell>
  );
};
